import { render, staticRenderFns } from "./SidebarLoadingWrapper.vue?vue&type=template&id=d07e1c84&scoped=true&lang=html&"
import script from "./SidebarLoadingWrapper.vue?vue&type=script&lang=js&"
export * from "./SidebarLoadingWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLoadingWrapper.vue?vue&type=style&index=0&id=d07e1c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07e1c84",
  null
  
)

export default component.exports